exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".float{position:fixed;width:60px;height:60px;bottom:40px;right:40px;background-color:#000;color:#fff;border-radius:50px;text-align:center;font-size:30px;box-shadow:2px 2px 3px #999;z-index:100}.my-float{margin-top:16px;color:#fff}a.icon-envelope,a.icon-phone,a.icon-whatsapp{color:#1a1a1a;font-size:25px}.title-li{line-height:16px}", ""]);

// exports
